import { Component, OnInit, Injector, AfterContentInit, OnDestroy } from '@angular/core';
import { includes, isEmpty, isUndefined, set } from 'lodash';
import * as bowser from 'bowser';
import { ModalService } from '../../../Services/modal-factory/modal-factory';
import { ReportEventService } from '../../../Services/report-event/report-event.service';
import { EventsComponent } from '../events/events.component';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';

@Component({
	selector: 'custom-button',
	host: { '[class]': 'myCustomClass', '[class.center]': 'centerHostElem' },
	template: `
		<button
			(click)="buttonClick()"
			gtm-handler
			[attr.gtm]="gaLabel"
			events="click"
			handlerType="button"
			role="button"
			[attr.aria-label]="setLabel()"
			[disabled]="control.disabled"
			[label]="gaLabel"
			[id]="buttonId"
			action="ButtonClick"
			[attributeVal]="gaLabel"
			class="custom-button {{ control.attributes.type ? control.attributes.type : '' }} {{
				control.attributes.buttonPosition ? control.attributes.buttonPosition : ''
			}} {{ control.attributes.class ? control.attributes.class : '' }} {{ control.disabled ? 'disabled' : '' }}"
		>
			<i
				class="icon left"
				*ngIf="control.attributes.iconPosition === 'left'"
				[class]="iconClass"
				[ngClass]="{ disabled: control.disabled }"
			></i>

			<span [class]="spanClass">{{ setLabel() }}</span>

			<i class="icon right" *ngIf="control.attributes.iconPosition === 'right'" [ngClass]="iconClass"></i>
		</button>
	`,
	styleUrls: ['./custom-button.component.scss'],
})
export class CustomButtonComponent extends EventsComponent implements OnInit, AfterContentInit, OnDestroy {
	isCodeDisabled: boolean;
	flowtype: string;
	centerHostElem: boolean;
	closeOnAction = ['redirecttodashboardnoquotestop'];
	spanClass: any[];
	iconClass: string;
	buttonId: string;
	constructor(
		injector: Injector,
		private modalService: ModalService,
		private reportevent: ReportEventService,
		private actionApiService: ActionApiService
	) {
		super(injector);
		this.buttonClick = this.buttonClick.bind(this);
	}

	ngOnInit() {
		this.gaLabel = this.control.attributes.label ? this.control.attributes.label.trim() : this.control.name;
		this.observablesService.unlockButtons.subscribe(() => {
			if (this.isCodeDisabled && this.control) {
				this.control.disabled = false;
			}
		});

		this.centerHostElem = this.control.attributes['centerHostElem'];

		// Info we found feature requires that attributes.value of Save button is passed to the server as the control value.
		if (typeof this.control.attributes.value !== 'undefined') {
			this.value = this.control.attributes.value;
		}
		this.spanClass = ['custom-text-button', this.control.attributes.spanClass];
		this.iconClass = this.getIconClass();
	}

	ngAfterContentInit() {
		if (this.control.attributes.label.includes('Next') || this.control.attributes.label.includes('Ok, Show Rates')) {
			this.buttonId = 'next-button';
		}
		setTimeout(() => {
			this.flowtype = '';
			if (this.storeService.getAddOnParams()) {
				var Quoteflowtype = this.storeService.getAddOnParams().dataLayerParams['channelType'];
				if (Quoteflowtype == 'Direct') {
					this.flowtype = 'Direct';
				} else {
					this.flowtype = Quoteflowtype;
				}
			}
		}, 0);
	}

	buttonClick() {
		if (this.control.attributes.reportEvent === 'splunkNextClick') {
			this.reportevent.addPageLoad('Forward');
		}

		if (this.control.attributes.splunkEvent) {
			let splunkEvent = this.control.attributes.splunkEvent;
			this.splunkAnalyticsService.publish(splunkEvent.event, splunkEvent.label);
		}

		this.control.attributes.url && window.location.assign(this.control.attributes.url);
		(!this.hasUrl() || this.control.attributes.mixaction) && this.onClick();

		var data = this.layoutService.staticLayout.getValue().data;

		if (data && data.metadata.page.stage == 'Owners') {
			const middleName = data.answers['page']['PolicyData.MiddleName'];
			if (middleName && middleName.length > 1) {
				var ownerInfoControl = Array.isArray(data.controls.page)
					? data.controls.page.find((x) => x.name == 'SectionClaim.OwnerInfo')
					: null;
				if (ownerInfoControl) {
					const { name, ajaxInfo } = ownerInfoControl;
					this.storeService.updateData(name, true, this.context);
					if (!isEmpty(ajaxInfo) && !isEmpty(ajaxInfo.action)) {
						const request = Object.assign(
							{},
							{
								data: this.storeService.getAnswers(this.context),
								info: ajaxInfo,
							}
						);

						this.actionService.invokeAction(request, true).then((response) => {
							setTimeout(() => {
								const spanElements = document.querySelectorAll('span');
								// Loop through all span elements to find the one containing the text
								spanElements.forEach((span) => {
									if (span.textContent.includes('Primary owner')) {
										// Scroll the span element into view if it contains the text
										span.scrollIntoView({
											behavior: 'smooth', // Smooth scrolling
											block: 'center', // Center the element in the viewport
										});
									}
								});
							}, 2000);
						});
					}
				}
			}
		}
	}

	getIconClass() {
		return `icon-${this.control.attributes.icon}`;
	}

	setTarget() {
		return !isEmpty(this.control.attributes.target) ? '_blank' : '';
	}

	hasUrl() {
		return !isEmpty(this.control.attributes.url);
	}

	onClick() {
		// stop closeModal action from going to the server & close the modal
		if (this.control.attributes.label) {
			this.splunkAnalyticsService.publish('ButtonClick', this.control.attributes.label, '');
		}

		if (this.control.ajaxInfo && this.control.ajaxInfo.action.toLowerCase() === 'closemodal') {
			this.modalService.close();
			return;
		} else if (this.control.ajaxInfo && this.closeOnAction.indexOf(this.control.ajaxInfo.action.toLowerCase()) > -1) {
			this.modalService.close();
		}

		!this.control.disabled && this.setAnswer(this.value);
		this.control.disabled = true;
		this.isCodeDisabled = true;
	}

	isConsumer() {
		return this.flowtype == 'Direct' ? true : false;
	}

	setLabel() {
		if (
			(this.isConsumer() && !isEmpty(this.control.attributes.mobilelabel)) ||
			(!isEmpty(this.control.attributes.mobilelabel) &&
				bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile')
		) {
			return this.control.attributes.mobilelabel;
		} else {
			let relevantLobs = [];
			if (this.control.attributes && this.control.attributes.specialLabelLobs) {
				const specialLobsStr = this.control.attributes.specialLabelLobs;
				if (includes(specialLobsStr, ',')) {
					relevantLobs = specialLobsStr.split(',');
				} else {
					relevantLobs.push(specialLobsStr);
				}
			}
			if (relevantLobs.length > 0) {
				let quoteLobs = [];
				if (
					this.storeService.getAddOnParams() &&
					this.storeService.getAddOnParams().dataLayerParams &&
					this.storeService.getAddOnParams().dataLayerParams['residencyProduct'] &&
					this.storeService.getAddOnParams().dataLayerParams['residencyProduct'].length == 1
				) {
					const relevantLobsStr = this.storeService.getAddOnParams().dataLayerParams['residencyProduct'][0];
					if (includes(relevantLobsStr, ',')) {
						quoteLobs = relevantLobsStr.split(',');
					} else {
						quoteLobs.push(relevantLobsStr);
					}
				}

				let isFound = false;
				relevantLobs.forEach((relevant) => {
					quoteLobs.forEach((existing) => {
						if (relevant === existing) {
							isFound = true;
						}
					});
				});

				return !isFound ? this.control.attributes.label : this.control.attributes.specialLabelText;
			} else {
				return this.control.attributes.label;
			}
		}
	}
}
